import { t } from "@/i18n-js/instance";
import { SpaceHeaderTitleText } from "@circle-react/components/Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";

export const Title = () => (
  <SpaceHeaderTitleText>{t("feed")}</SpaceHeaderTitleText>
);
